import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormWhyChooseUsSection from "../../components/why-choose-us/FormWhyChooseUsSection";
import { useGetWhyChooseUsSection } from "../../hooks/why-choose-us/useGetWhyChooseUsSection";
import { useUpdateWhyChooseUsSection } from "../../hooks/why-choose-us/useUpdateWhyChooseUsSection";

const WhyChooseUsSection = () => {
    const { whyChooseUsSection, isLoading: isFetching } = useGetWhyChooseUsSection();
    const { mutate, isPending: isUpdating } = useUpdateWhyChooseUsSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormWhyChooseUsSection
                currentData={whyChooseUsSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default WhyChooseUsSection;
